module.exports = __webpack_public_path__ + "img/chevron-down-light.a2c3b8dd.svg";